import type { TypographyTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const typographyDark: TypographyTheme = {
  name: 'Typography',
  common: commonDark,
  self
}

export default typographyDark
